import { List, ListItem, ListItemText, Popover, Tooltip, Typography } from '@mui/material';
import * as React from 'react';
import { IB } from '../../../page/portal/setting/SettingPanel';
import { EditNotifications } from '@mui/icons-material';

export default function CamelNotifiPopover(props) {
    const { action, setCode } = props;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const id = open ? 'camelNotif-popover' : undefined;

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const doAction = (script) => {
        if (action) action(script);
        handleClose();
    }

    return (
        <React.Fragment>
            <Tooltip title="Operações Notificação">
                <IB
                    color='primary'
                    onClick={handleClick}
                    size="small"
                >
                    <EditNotifications />
                </IB>
            </Tooltip>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }} dense={true}>
                    <ListItem sx={{ cursor: 'pointer' }} onClick={() => doAction('camel-js-mongo-notificaTodos.js')}>
                        <ListItemText
                            primary="Notifica todos"
                        />
                    </ListItem>
                    <ListItem sx={{ cursor: 'pointer' }} onClick={() => doAction('camel-js-mongo-notificaHasAccess.js')}>
                        <ListItemText
                            primary="Notifica todos com acesso"
                        />
                    </ListItem>
                    <ListItem sx={{ cursor: 'pointer' }} onClick={() => doAction('camel-js-mongo-notificaOrganograma.js')}>
                        <ListItemText
                            primary="Notifica Setor Organograma"
                        />
                    </ListItem>
                </List>
            </Popover>
        </React.Fragment>
    )
}